import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {RoutingGroupApiService} from '../../../services/api/routing-group/routing-group-api.service';
import {CallStudioApiService} from '../../../services/api/settings/call-flow-configurations/call-studio/call-studio-api.service';
import {RoutingRuleApiService} from '../../../services/api/routing/routing-rule/routing-rule-api.service';
import * as _ from 'lodash';
import {LoaderService} from '../../../services/common/loader-service/loader.service';

@Component({
  selector: 'user-groups-summary',
  templateUrl: './user-groups-summary.component.html',
  styleUrls: ['./user-groups-summary.component.scss']
})
export class UserGroupsSummaryComponent implements OnInit {
  selectedUserGroup;
  routingGroupIdToNameMap;

  constructor(private routingRuleApi: RoutingRuleApiService,
              private callStudioApiService: CallStudioApiService,
              private routingGroupApiService: RoutingGroupApiService,
              private loaderService: LoaderService) { }

  @Input() set selection(selection) {
    this.selectedUserGroup = _.cloneDeep(selection);

    if (_.isNil(selection)) {
      return;
    }

    const params = {
      userGroupId: {
        value: selection.id,
        operator: '='
      }
    };

    this.loaderService.showSidePanel();
    Promise.all([this.routingRuleApi.getRules({filter: params}),
      this.callStudioApiService.getCallsItemsFiltered({filter: params})])
        .then((value) => {

          let rules = _.chain(value[0].elements)
              .groupBy('rrGroupId')
              .map((ruleValue, key) => ({[this.routingGroupIdToNameMap[key]]: ruleValue.map(rule => rule.name)})).value();

          rules = Object.assign({}, ...rules);

          const policyStudio = value[1].map((rule) => rule.name);

          this.selectedUserGroup.rules = _.isEmpty(rules) ? 'None' : rules;
          this.selectedUserGroup.policyStudioInfo = (_.isArray(policyStudio) && policyStudio.length > 0)
              ? policyStudio.join(', ') : 'None';
          this.loaderService.hideSidePanel();
        }).catch(() => {
          this.loaderService.hideSidePanel();
    });
  }

  ngOnInit(): void {
    this.routingGroupApiService.getGroupsSlim().then(groups => {
      this.routingGroupIdToNameMap = _.mapValues(_.keyBy(groups, 'id'), 'name');
    });
  }


}
